module.exports = __webpack_public_path__ + "static/media/commitment.866ad69d.svg";